import * as XLSX from 'xlsx-js-style'

const setExcelAlignment = (cell) => {
    if (cell.r === 0) {
        return {
            wrapText: '0', // any truthy value here
        }
    }
    if (cell.r === 3 || cell.r === 4) {
        return {
            vertical: "center",
            horizontal: "center",
            wrapText: '1', // any truthy value here
        }
    }
    else {
        return {
            vertical: "top",
            horizontal: "left",
            wrapText: '1', // any truthy value here
        }
    }
}

export const applyStyles = (workSheet) => {
    for (let i in workSheet) {
        if (typeof (workSheet[i]) != "object") continue;
        let cell = XLSX.utils.decode_cell(i);

        workSheet[i].s = { // styling for all cells
            font: {
                name: "arial",
                bold: cell.r === 0 || cell.r === 3 || cell.r === 4
            },
            alignment: {
                ...setExcelAlignment(cell)
            },
            border: {
                right: {
                    style: "thin",
                    color: "000000"
                },
                left: {
                    style: "thin",
                    color: "000000"
                },
                top: {
                    style: "thin",
                    color: "000000"
                },
                bottom: {
                    style: "thin",
                    color: "000000"
                },
            }
        };

        if ((cell.r === 1) || (cell.r === 2)) {
            workSheet[i].s.border = { // bottom border
                right: {
                    style: "none",
                },
                left: {
                    style: "none",
                },
                bottom: {
                    style: "none",
                },
                top: {
                    style: "none"
                }
            };
        }
        // Removed merged borders for TotalAlarms, UpdatedBy, UpdatedOn
        if (cell.r === 4 && ([22, 23, 24, 25, 26, 27].includes(cell.c))) {
            workSheet[i].s.border.top = { // bottom border
                style: "none"
            };
        }
        if (cell.r === 3 && ([22, 23, 24, 25, 26, 27].includes(cell.c))) {
            workSheet[i].s.border.bottom = { // bottom border
                style: "none"
            };
        }
        if (cell.r === 3 && ([23, 25, 26].includes(cell.c))) {
            workSheet[i].s.border.right = { // bottom border
                style: "none"
            };
        }
        if (cell.r === 3 && ([24, 26, 27].includes(cell.c))) {
            workSheet[i].s.border.left = { // bottom border
                style: "none"
            };
        }

        if (cell.r == 0 || cell.r >= 5) {
            workSheet[i].s.fill = { // background color
                patternType: "solid",
                fgColor: { rgb: "fff0f0f0" },
                bgColor: { rgb: "fff0f0f0" }
            };
        }
        if (cell.r == 3 || cell.r == 4) {
            workSheet[i].s.fill = { // background color
                bgColor: { rgb: "ff91d2ff" },
                fgColor: { rgb: "ff91d2ff" },
            };
        }
    }
    return workSheet
}
